import script from "./categorylist.vue?vue&type=script&setup=true&lang=js"
export * from "./categorylist.vue?vue&type=script&setup=true&lang=js"

import "./categorylist.vue?vue&type=style&index=0&id=c6d90e88&lang=css"

const __exports__ = script;

export default __exports__